import React from 'react';
import PropTypes from 'prop-types';
import { ReactComponent as Export } from '../../../webcommon/common/Icons/Export.svg';
import { CSVLink } from 'react-csv';
import { noop } from 'lodash';
import styles from '../GridHeaderButton.module.scss';

const ExportAsCsvButton = props => (
    props.csvData.length > 0 ? (
        <CSVLink
            data={ props.csvMapping(props.csvData) }
            filename={ props.csvFilename }
        >
            <button className={ styles.gridHeaderButton } type="button">
                Export Result <Export />
            </button>
        </CSVLink>
    ) : (
        <button
            onClick={ () => { props.csvExportEmpty('No data available for the CSV'); } }
            className={ styles.gridHeaderButton }
            type="button"
        >
            Export Result <Export />
        </button>
    )
);

ExportAsCsvButton.propTypes = {
    csvData: PropTypes.arrayOf(PropTypes.shape({})),
    csvExportEmpty: PropTypes.func,
    csvFilename: PropTypes.string.isRequired,
    csvMapping: PropTypes.func
};

ExportAsCsvButton.defaultProps = {
    csvData: [],
    csvExportEmpty: noop,
    csvMapping: row => row
};

export default ExportAsCsvButton;
